import {Button, Form, Modal, Row, Space, Table} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {columns} from "./ModalResults.config";
import {glassStoreService} from "api";
import {exportFile} from "helper/common";
import {ListActionButton, ModalCustom} from "components/common";
import ReceiptModal from "../../Detail/ReceiptModal/ReceiptModal";
import BillModal from "pages/Glass/GlassKiosk/Detail/BillModal/BillModal";
import {setDetailRecord} from "redux/reducer/glassStore";
import {useAppDispatch} from "redux/hooks";
import {getDetailBillAPI} from "redux/reducer/glassKiot";
const ModalResults = ({isShowModal, handleOk, handleCancel, soLo}) => {
  const [formData] = Form.useForm();
  const [data, setData] = useState([]);
  const billRef = useRef<any>();
  const dispatch = useAppDispatch();
  const receiptRef = useRef<any>();
  useEffect(() => {
    columns.find(e => e.dataIndex == "action").render = (
      value,
      record,
      index
    ) => {
      return (
        <ListActionButton reportFunction={exportReport}></ListActionButton>
      );
    };
  }, [soLo]);
  const exportReport = () => {
    // console.log(soLo);
    exportFile(
      "store/glasses-store/export-lich-su-xn",
      {soLo: soLo},
      `Lịch sử nhập xuất lô ${soLo}`
    );
  };
  useEffect(() => {
    if (soLo) {
      getLichSuNhapXuatBySoLo(soLo);
    }
  }, [soLo]);
  const getDetailReceipt = async id => {
    try {
      const res = await glassStoreService.getDetailReceipt(id);
      dispatch(setDetailRecord(res));
    } catch (error) {}
  };
  const showBill = item => {
    // console.log(item);
    if (item?.loaiDon == 1) {
      billRef?.current.openModal();
      dispatch(getDetailBillAPI(item?.phieuThamChieuId));
    } else if (item?.loaiDon == 0) {
      receiptRef?.current.openModal();
      getDetailReceipt(item?.receiptId);
    }
  };
  const getLichSuNhapXuatBySoLo = async soLo => {
    try {
      let res = await glassStoreService.getLichSuXuatNhapBySoLo(soLo);
      const dataFormat = formatData(res);
      setData(dataFormat);
    } catch (error) {}
  };
  const formatData = response => {
    const data = response.map(e => ({
      ...e?.receiptDto,
      ...e?.listGlassesReceiptDetailDto[0],
      createDate: e?.receiptDto?.createDate,
    }));
    return data;
  };
  return (
    <Modal
      title="Thông tin lịch sử xuất nhập"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"100%"}
      className="modal-tab-pay"
      footer=""
    >
      <div style={{padding: "16px"}}>
        <Form form={formData}>
          <Table
            pagination={false}
            bordered
            dataSource={data}
            columns={columns}
            scroll={{x: 1500}}
            onRow={record => ({
              onDoubleClick: () => showBill(record),
            })}
          />
          {/* <Form.Item>
            <Row justify={"end"} style={{padding: "16px"}}>
              <Space>
                <Button
                  key="cancel"
                  type="primary"
                  danger
                  onClick={handleCancel}
                >
                  Huỷ bỏ
                </Button>
                ,
                <Button
                  key="submit"
                  type="primary"
                  htmlType="submit"
                  onClick={handleCancel}
                >
                  Duyệt
                </Button>
              </Space>
            </Row>
          </Form.Item> */}
        </Form>
      </div>
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={billRef}
        width={1100}
        centered
      >
        <BillModal />
      </ModalCustom>
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={receiptRef}
        width={1100}
        centered
      >
        <ReceiptModal />
      </ModalCustom>
    </Modal>
  );
};

export default ModalResults;
